import React, { useContext } from 'react';
import { FaTrash, FaTimes } from 'react-icons/fa';
import Numbers from '~/utils/numbers';
import Dates from '~/utils/dates';
import { ModalContext } from '~/contexts';
import './styles.css';

interface DeletePriceModalProps {
    price: any;
    onConfirm: () => void;
    onCancel: () => void;
}

const DeletePriceModal: React.FC<DeletePriceModalProps> = ({ price, onConfirm, onCancel }) => {
    const Modal = useContext(ModalContext);

    function formatPrice(value: string | number) {
        if (typeof value === 'undefined') return '';
        else if (typeof value === 'string') return Numbers.money(parseFloat(value.replace('.', '').replace(',', '.')), false, true);
        return Numbers.money(value, false, true);
    }

    function getMonthName(month: number) {
        month = Number(month);
        if (month === 0) return 'Geral';
        return Dates._getNameMonth((month - 1));
    }

    function handleConfirm() {
        onConfirm();
    }

    function handleCancel() {
        onCancel();
    }

    return (
        <div className="price-modal-container">
            <div className="price-modal-header">
                <h3>Excluir Preço</h3>
            </div>

            <div className="price-modal-body">
                <div className="delete-confirmation">
                    <div className="warning-icon">
                        <FaTrash size={48} color="#dc3545" />
                    </div>
                    
                    <div className="confirmation-text">
                        <p>Deseja realmente excluir este preço?</p>
                        
                        <div className="price-details">
                            <div className="detail-item">
                                <strong>Ano:</strong> {price.year}
                            </div>
                            <div className="detail-item">
                                <strong>Mês:</strong> {getMonthName(price.month)}
                            </div>
                            <div className="detail-item">
                                <strong>Valor:</strong> R$ {formatPrice(price.price || '0.00')}
                            </div>
                            <div className="detail-item">
                                <strong>Tipo:</strong> {price.type || 'FIXO'}
                            </div>
                        </div>
                        
                        <div className="warning-text">
                            <strong>⚠️ Atenção:</strong> Esta ação não pode ser desfeita!
                        </div>
                    </div>
                </div>
            </div>

            <div className="price-modal-footer">
                <button className="btn-cancel" onClick={handleCancel}>
                    Cancelar
                </button>
                <button className="btn-delete" onClick={handleConfirm}>
                    <FaTrash size={16} />
                    Excluir Preço
                </button>
            </div>
        </div>
    );
};

export default DeletePriceModal;
